export interface UserReferralCodeStatsDto {
  count: number
}

export interface UserReferralCodeStatsModel {
  referralCounter: number
}

export const userReferralCodeStatTransformer = (dto: UserReferralCodeStatsDto): UserReferralCodeStatsModel => ({
  referralCounter: dto.count ?? 0,
})
